import { FieldsService } from "smck-service";
import ReservationService from "@/service/reservation-service";
import CompanyService from "@/service/company-service";
import find from "lodash/find";
import { FlashMessageService } from "zoox-infra";
import Vue from "vue";
import uuid from "uuid";
import { mapActions, mapState } from "vuex";
import { zLanguageChanger, zModalReservationCanceled } from "zoox-components";
import sessionMixin from "@/components/shared/mixins/sessionMixin";
import lodash from "lodash";

import DesktopContent from "./DesktopContent.vue";
import MobileContent from "./MobileContent.vue";

export default {
  name: "Home",
  mixins: [sessionMixin],
  components: {
    DesktopContent,
    MobileContent,
    zModalReservationCanceled,
    "z-language-changer": zLanguageChanger
  },
  data() {
    return {
      activeTab: 0,
      isActive: false,
      currentCompany: {},
      customizationSettings: {},
      enableRecognition: true,
      enableZooxpay: false,
      reservationService: new ReservationService(),
      companyService: new CompanyService(),
      fieldsService: new FieldsService(Vue),
      fieldSettingsData: { isEmpty: true },
      chargeToPayAtCheckin: null,
      chargeToPayAtCheckinWatched: null,
      colorCustomization: {},
      tabHistory: [],
      enabledScanTab: false,
      emailNotRequired: false,
      jobNotRequired: false,
      isMaster: false,
      orientationTexts: null,
      openModalCanceled: false
    };
  },
  computed: Object.assign(
    {},
    mapState([
      "currentReservation",
      "isQualifiedGuest",
      "currentGuest",
      "currentPhoto"
    ])
  ),
  watch: {
    currentReservation: function(data) {
      if (
        data &&
        data.guests &&
        this.$route.params &&
        this.$route.params.guestId
      ) {
        const currentGuest = find(data.guests, item => {
          return item.id === this.$route.params.guestId;
        });

        if (
          data.order &&
          data.order.chargesAtCheckin &&
          data.order.chargesAtCheckin.length &&
          !this.chargeToPayAtCheckin
        ) {
          const lastCharge = lodash.orderBy(
            data.order.chargesAtCheckin,
            ["updateAt"],
            ["desc"]
          )[0];

          if (
            lastCharge &&
            lastCharge.metadata &&
            lastCharge.metadata.origin === "at_checkin" &&
            ["pending"].includes(lastCharge.status)
          ) {
            lastCharge.order = JSON.parse(JSON.stringify(data.order));
            this.chargeToPayAtCheckin = lastCharge;
          }
        }

        this.isMaster = currentGuest.masterGuest || false;
      }
    },
    currentMobileStep() {
      this.scrollTop();
    },
    chargeToPayAtCheckin(val) {
      this.chargeToPayAtCheckinWatched = val;
    }
  },
  async beforeMount() {
    const { reservationId } = this.$route.params;
    const $context = this;

    $context.currentCompany = $context.companyService.getLocalCompany();

    $context.fieldSettingsData = await $context.fieldsService.getFormattedFields(
      $context.currentCompany.id
    );

    const checkReservation = await this.reservationService.checkIfReservationIsExpiredOrCanceled(
      reservationId
    );

    if (checkReservation.status === true) {
      this.openModalCanceled = true;
    } else {
      this.openModalCanceled = false;
    }
  },
  async mounted() {
    const $context = this;
    $context.addTabHistory(0);
    $context.customizationSettings = $context.companyService.getLocalCustomizationSettings();
    $context.enabledScanTab = true;
    // $context.$customization && $context.$customization.enableDocumentScan;

    if (
      $context.currentCompany &&
      $context.currentCompany.parameters_sc &&
      $context.currentCompany.parameters_sc.globalSettings
    ) {
      $context.enableRecognition =
        $context.currentCompany.parameters_sc.globalSettings
          .enableRecognition !== false;
      $context.enableZooxpay =
        $context.currentCompany.parameters_sc.globalSettings.enableZooxpay;
    }

    if ($context.currentCompany && $context.currentCompany.parameters_sc) {
      this.orientationTexts =
        $context.currentCompany.parameters_sc.orientationTexts;
    }

    Vue.$globalEvent.$on("tabChange", index => {
      $context.onTabChanged(index);
    });

    Vue.$globalEvent.$on("requiredEmail", value => {
      this.emailNotRequired = value;
    });

    Vue.$globalEvent.$on("requiredJob", value => {
      this.jobNotRequired = value;
    });

    if (process.env.NODE_ENV !== "development") {
      window.onbeforeunload = function() {
        return $context.$t("GLOBAL.PREVENT_RELOAD");
      };
    }
  },
  destroyed() {
    window.onbeforeunload = null;
  },
  methods: Object.assign(
    {
      onTabChanged: function(tabIndex, addToHistory) {
        // para prevenir adicionar ao historico se evento vier dos componentes filhos

        if (addToHistory) {
          this.addTabHistory(tabIndex);
        }

        if (tabIndex != null && typeof tabIndex === "number") {
          if (
            this.currentReservation &&
            this.currentReservation.guests &&
            this.$route.params &&
            this.$route.params.guestId
          ) {
            let currentGuestLocal = find(
              this.currentReservation.guests,
              item => {
                return item.id === this.$route.params.guestId;
              }
            );

            let currentGuestFromSession = this.currentGuest;

            if (
              Object.keys(currentGuestFromSession).length >=
              Object.keys(currentGuestLocal).length
            ) {
              if (
                currentGuestLocal.documents &&
                !currentGuestFromSession.documents &&
                currentGuestLocal.id === currentGuestFromSession.id
              ) {
                currentGuestFromSession.documents = currentGuestLocal.documents;
              }
              if (currentGuestLocal.id === currentGuestFromSession.id)
                currentGuestLocal = currentGuestFromSession;
            }

            if (
              !currentGuestLocal.documents &&
              currentGuestFromSession.documents &&
              currentGuestLocal.id === currentGuestFromSession.id
            ) {
              currentGuestLocal.documents = currentGuestFromSession.documents;
            }

            this.isMaster = currentGuestLocal.masterGuest || false;

            if (currentGuestLocal && tabIndex > 0) {
              if (
                !this.validateGuest(
                  currentGuestLocal,
                  this.fieldSettingsData,
                  true
                )
              ) {
                FlashMessageService.warning(
                  this.$t("GLOBAL.INVALID_GUEST_NAVIGATION")
                );
                this.activeTab = 0;
                return;
              } else {
                if (currentGuestLocal.id === currentGuestFromSession.id)
                  this.currentReservation.guests[
                    this.currentReservation.guests.findIndex(
                      guest => guest.id === currentGuestLocal.id
                    )
                  ] = currentGuestFromSession;

                this.$setCurrentReservation(this.currentReservation);

                Vue.$globalEvent.$emit("tabChanged", {
                  previousTab: this.getPreviousTab()
                });
              }
            } else if (currentGuestLocal && tabIndex === 0) {
              if (currentGuestFromSession.id !== this.$route.params.guestId) {
                this.$setCurrentGuest(currentGuestLocal);
                this.$setCurrentReservation(this.currentReservation);
              }
            }
          }
          this.activeTab = tabIndex;
        }
        this.$nextTick(() => this.scrollTop());
      },
      scrollTop: function() {
        this.$refs.content.scrollTop = 0;
      },
      updateVuexGuest(guest) {
        this.currentGuest = guest;
        this.$setCurrentGuest(guest);
      },
      validateGuest: function(guest, config, excludeOtherInfo = false) {
        if (guest.documentTypeId == null) {
          guest.documentTypeId = guest.documents[0].documentTypeId;
        }
        const isValid = this.reservationService.validateGuest(
          guest,
          config,
          excludeOtherInfo,
          this.emailNotRequired,
          this.jobNotRequired
        );
        if (!isValid) {
          Vue.$globalEvent.$emit("guestValidationError");
        }
        return isValid;
      },
      toggleMenu: function() {
        this.isActive = !this.isActive;
      },
      getLogoUrl: function() {
        return this.customizationSettings.portalLogoUrl
          ? this.customizationSettings.portalLogoUrl + `?unique=${uuid.v4()}`
          : require("@/assets/images/logo-smart.png");
      },
      addTabHistory: function(tabIndex) {
        const found = this.tabHistory.find(element => element === tabIndex);
        if (!found) {
          this.tabHistory.push(tabIndex);
        }
      },
      setChargeToPayAtCheckin(data) {
        this.chargeToPayAtCheckin = data;
        this.chargeToPayAtCheckinWatched = this.chargeToPayAtCheckin;
      },
      getPreviousTab: function() {
        if (this.tabHistory && this.tabHistory.length === 4) {
          return this.tabHistory[2];
        } else if (this.tabHistory && this.tabHistory.length === 3) {
          return this.tabHistory[1];
        } else if (this.tabHistory && this.tabHistory.length === 2) {
          return this.tabHistory[0];
        } else {
          return 0;
        }
      }
    },
    mapActions(["$setCurrentReservation", "$setCurrentGuest"])
  )
};
